import styled from 'styled-components';

import { Heading2 } from 'packages/smart-home-support/components/Typography';

export default styled(Heading2)`
  margin-bottom: 15px;
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/TestimonialTitle.tsx